import React, { useEffect, useState } from "react";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import Select from "react-select";
import {
  DistanceCountPayloadType,
  ExtendEWayBillPayloadType,
} from "../../../commonTypes/invoiceGenerationTypes";
import {
  checkDistanceCountAction,
  postExtendEWayBillAction,
  resetEWayBillError,
  resetPinCodeDistanceCountData,
  resetPinCodeError,
} from "../../../redux/invoiceGeneration";
import useDebounce from "../../../customHooks/useDebounce";
import {
  EWayBillReviewDataType,
  PinCodeDistanceCountDataType,
} from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import toast from "react-hot-toast";
import { RollingLoader } from "../../commons";
import { CalenderIcon } from "../../Icon";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  getAllCityAction,
  getAllStateAction,
  resetCityList,
  resetStateList,
} from "../../../redux/masterData";
import {
  GetCityListDataPayloadType,
  GetStateListDataPayloadType,
} from "../../../commonTypes/masterDataTypes";
import {
  CityListTypes,
  StateListTypes,
} from "../../../redux/masterData/masterTypes";
import { returnInputFieldLength } from "../../../utils/commonFunctions";
export const REASONS_FOR_EXTENSION = [
  { value: "Natural Calamity", label: "Natural Calamity" },
  { value: "Law and Order Situation", label: "Law and Order Situation" },
  { value: "Transshipment", label: "Transshipment" },
  { value: "Accident", label: "Accident" },
  { value: "Others", label: "Others" },
];
export const TRANSIT_TYPE = [
  { value: "Road", label: "Road" },
  { value: "Warehouse", label: "Warehouse" },
];
export const CONSIGNMENT_STATUS = [
  { value: "M", label: "In Movement" },
  { value: "T", label: "In Transit" },
];

export const MODE = [
  { value: "Road", label: "Road" },
  { value: "Air", label: "Air" },
  { value: "Ship", label: "Ship" },
  { value: "Rail", label: "Rail" },
];

type AppProps = {
  clientCode: null | number;
  dispatchGetGenerateEWayBillAction: (data: ExtendEWayBillPayloadType) => void;
  token: string | null;
  dispatCheckDistanceCountAction: (data: DistanceCountPayloadType) => void;
  data: EWayBillReviewDataType;
  pinCodeDistanceCountData: PinCodeDistanceCountDataType | any;
  pinCodeFetching: boolean;
  pinCodeError: string;
  eWayBillInvoiceId: string | number;
  type: string;
  dispatchResetPinCodeError: () => void;
  dispatchResetPinCodeDistanceCountData: () => void;
  eWayBillExtend: ExtendEWayBillPayloadType;
  setEWayBillExtend: React.Dispatch<
    React.SetStateAction<ExtendEWayBillPayloadType>
  >;
  inputDetailsError: any;
  setInputDetailsError: any;
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) => void;
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) => void;
  dispatchResetStateList: () => void;
  dispatchResetCityList: () => void;
  stateList: StateListTypes[] | [];
  cityList: CityListTypes[] | [];
  dispatchResetEWayBillError: () => void;
  countryFetching: boolean;
  stateFetching: boolean;
};

const EWayBillExtend = ({
  clientCode,
  dispatchGetGenerateEWayBillAction,
  token,
  dispatCheckDistanceCountAction,
  data,
  pinCodeDistanceCountData,
  pinCodeFetching,
  pinCodeError,
  eWayBillInvoiceId,
  type,
  dispatchResetPinCodeError,
  dispatchResetPinCodeDistanceCountData,
  eWayBillExtend,
  setEWayBillExtend,
  inputDetailsError,
  setInputDetailsError,
  dispatchGetAllStateAction,
  dispatchGetAllCityAction,
  dispatchResetStateList,
  dispatchResetCityList,
  stateList,
  cityList,
  dispatchResetEWayBillError,
  countryFetching,
  stateFetching,
}: AppProps) => {
  const [finalStateList, setFinalStateList] = useState<any>([]);

  const [finalCityList, setFinalCityList] = useState<any>([]);

  const [stateSelect, setStateSelect] = useState("");

  useEffect(() => {
    dispatchResetPinCodeError();
    dispatchResetPinCodeDistanceCountData();
    dispatchResetStateList();
    dispatchResetCityList();
    setInputDetailsError({
      remainingDistance: "",
      extendValidityReason: "",
      extendRemarks: "",
      fromPincode: "",
      consignmentStatus: "",
      transitType: "",
      transporterDocumentDate: "",
      transporterDocumentNumber: "",
      modeOfTransport: "",
      vechileNumber: "",
      currentStateOfConsignor: "",
      currentPlaceOfConsignor: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let finalData: GetStateListDataPayloadType = {
      token,
      country_id: 101,
    };
    dispatchGetAllStateAction(finalData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const finalCityData = cityList?.map((data: any) => {
      return {
        value: data?.name,
        label: data?.name,
      };
    });
    setFinalCityList([...finalCityData]);
  }, [cityList]);

  useEffect(() => {
    const finalStateData = stateList?.map((data: any) => {
      return {
        value: data?.name,
        label: data?.name,
        id: data?.id,
      };
    });
    setFinalStateList(finalStateData);
  }, [stateList]);

  useEffect(() => {
    if (stateSelect) {
      let finalData: GetCityListDataPayloadType = {
        token,
        state_id: stateSelect,
      };
      dispatchGetAllCityAction(finalData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateSelect]);

  useEffect(() => {
    if (eWayBillExtend?.consignment_status === "M") {
      setEWayBillExtend((prev: ExtendEWayBillPayloadType) => ({
        ...prev,
        transit_type: "",
        address_line1: "",
        address_line2: "",
        address_line3: "",
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eWayBillExtend?.consignment_status]);

  const handleSubmit = () => {
    dispatchResetEWayBillError();
    const errors: any = {};

    if (!eWayBillExtend?.from_pincode) {
      errors.fromPincode = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          fromPincode: "error",
        };
      });
    }
    if (!eWayBillExtend?.remaining_distance) {
      errors.remainingDistance = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          remainingDistance: "error",
        };
      });
    }
    if (!eWayBillExtend?.extend_validity_reason) {
      errors.extendValidityReason = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          extendValidityReason: "error",
        };
      });
    }
    if (!eWayBillExtend?.extend_remarks) {
      errors.extendRemarks = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          extendRemarks: "error",
        };
      });
    }

    if (!eWayBillExtend?.mode_of_transport) {
      errors.modeOfTransport = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          modeOfTransport: "error",
        };
      });
    }

    if (
      !eWayBillExtend?.vechile_number &&
      eWayBillExtend?.mode_of_transport === "Road" &&
      eWayBillExtend?.mode_of_transport
    ) {
      errors.vechileNumber = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          vechileNumber: "error",
        };
      });
    }
    if (!eWayBillExtend?.current_state_of_consignor) {
      errors.currentStateOfConsignor = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          currentStateOfConsignor: "error",
        };
      });
    }
    if (!eWayBillExtend?.current_place_of_consignor) {
      errors.currentPlaceOfConsignor = "error";
      setInputDetailsError((prv: any) => {
        return {
          ...prv,
          currentPlaceOfConsignor: "error",
        };
      });
    }
    if (Object.keys(errors).length > 0) {
      toast.error("Please Fill Required Fields!", {
        duration: 2000,
      });
      setInputDetailsError(errors);
    } else {
      let finalData = {
        token,
        clientCode,
        ...eWayBillExtend,
      };
      dispatchGetGenerateEWayBillAction(finalData);
    }
  };

  const handleChange = (e: any) => {
    setEWayBillExtend((prv: ExtendEWayBillPayloadType) => {
      return {
        ...prv,
        [e.target.name]: e.target.value,
      };
    });
  };

  return (
    <div className="e-way-action-box p-0" style={{ height: "fit-content" }}>
      <div className="sub-heading-e-invoice ml-0 p-3">E-Way Bill Actions</div>
      <hr className="m-0"></hr>
      <div className="p-3">
        <div className="sub-heading-e-invoice mb-3 ml-0">EXTEND E-WAY BILL</div>
        <div className="mb-2">
          Please fill the fields below to extend e-way bill
        </div>

        <div className="row mt-2">
          <div className="col-md-6">
            <label htmlFor="dateOfBirth">Transporter Document Date</label>
            <div className="d-flex flex-row position-relative">
              <div className="date-picker-wraper mr-0 w-100">
                <Label className="mr-0 w-100">
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    className={`form-control ${
                      inputDetailsError?.transporterDocumentDate
                        ? "error-border rounded"
                        : ""
                    }`}
                    selected={
                      eWayBillExtend?.transporter_document_date
                        ? new Date(
                            moment(
                              `${eWayBillExtend?.transporter_document_date}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      setEWayBillExtend((prv: ExtendEWayBillPayloadType) => {
                        return {
                          ...prv,
                          transporter_document_date: e
                            ? moment(e).format("YYYY-MM-DD")
                            : null,
                        };
                      });
                      setInputDetailsError((prv: any) => {
                        return {
                          ...prv,
                          transporterDocumentDate: "",
                        };
                      });
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    placeholderText="Select"
                  />
                  <span
                    className="calender-icon"
                    style={{
                      right: "20px",
                      top: "10px",
                      cursor: "pointer",
                    }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <label>Transporter Document No.</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control ${
                  inputDetailsError?.transporterDocumentNumber
                    ? "error-border"
                    : ""
                }`}
                name="transporter_document_number"
                value={eWayBillExtend?.transporter_document_number}
                onChange={(e: any) => {
                  handleChange(e);
                  setInputDetailsError((prv: any) => {
                    return {
                      ...prv,
                      transporterDocumentNumber: "",
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-md-6">
            <label>
              Transportation Mode <span className="color-red">*</span>
            </label>
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Mode"}
              className={` ${
                inputDetailsError?.modeOfTransport ? "error-border rounded" : ""
              }`}
              options={MODE}
              value={{
                value: eWayBillExtend?.mode_of_transport
                  ? eWayBillExtend?.mode_of_transport
                  : null,
                label: eWayBillExtend?.mode_of_transport
                  ? eWayBillExtend?.mode_of_transport
                  : "Select...",
              }}
              // isLoading={userFetching}
              onChange={(e: any) => {
                setEWayBillExtend((prv: ExtendEWayBillPayloadType) => {
                  return {
                    ...prv,
                    mode_of_transport: e?.value,
                  };
                });
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    modeOfTransport: "",
                  };
                });
              }}
              isSearchable={true}
            />
          </div>

          <div className="col-md-6">
            <label>
              Vehicle Number{" "}
              {eWayBillExtend?.mode_of_transport === "Road" ? (
                <span className="color-red">*</span>
              ) : (
                ""
              )}
            </label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                disabled={eWayBillExtend?.mode_of_transport !== "Road"}
                className={`form-control ${
                  inputDetailsError?.vechileNumber ? "error-border" : ""
                }`}
                name="vechile_number"
                value={eWayBillExtend?.vechile_number}
                onChange={(e: any) => {
                  handleChange(e);
                  setInputDetailsError((prv: any) => {
                    return {
                      ...prv,
                      vechileNumber: "",
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-md-6">
            <label>
              State <span className="color-red">*</span>
            </label>
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Mode"}
              isLoading={stateFetching}
              className={` ${
                inputDetailsError?.currentStateOfConsignor
                  ? "error-border rounded"
                  : ""
              }`}
              options={finalStateList}
              value={{
                value: eWayBillExtend?.current_state_of_consignor
                  ? eWayBillExtend?.current_state_of_consignor
                  : null,
                label: eWayBillExtend?.current_state_of_consignor
                  ? eWayBillExtend?.current_state_of_consignor
                  : "Select...",
              }}
              // isLoading={userFetching}
              onChange={(e: any) => {
                setStateSelect(e?.id);

                setEWayBillExtend((prv: ExtendEWayBillPayloadType) => {
                  return {
                    ...prv,
                    current_state_of_consignor: e?.value,
                    current_place_of_consignor: "",
                  };
                });
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    currentStateOfConsignor: "",
                  };
                });
              }}
              isSearchable={true}
            />
          </div>

          <div className="col-md-6">
            <label>
              City <span className="color-red">*</span>
            </label>
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Mode"}
              isDisabled={!eWayBillExtend?.current_state_of_consignor}
              className={` ${
                inputDetailsError?.currentPlaceOfConsignor
                  ? "error-border rounded"
                  : ""
              }`}
              isLoading={countryFetching}
              options={finalCityList}
              value={{
                value: eWayBillExtend?.current_place_of_consignor
                  ? eWayBillExtend?.current_place_of_consignor
                  : null,
                label: eWayBillExtend?.current_place_of_consignor
                  ? eWayBillExtend?.current_place_of_consignor
                  : "Select...",
              }}
              // isLoading={userFetching}
              onChange={(e: any) => {
                setEWayBillExtend((prv: ExtendEWayBillPayloadType) => {
                  return {
                    ...prv,
                    current_place_of_consignor: e?.value,
                  };
                });
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    currentPlaceOfConsignor: "",
                  };
                });
              }}
              isSearchable={true}
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-6">
            <label>
              Pincode <span className="color-red">*</span>
            </label>
            <div className="d-flex flex-row position-relative">
              <input
                type="number"
                className={`form-control ${
                  inputDetailsError?.fromPincode ? "error-border" : ""
                }`}
                value={
                  eWayBillExtend?.from_pincode
                    ? eWayBillExtend?.from_pincode
                    : ""
                }
                name="from_pincode"
                onChange={(e: any) => {
                  handleChange(e);
                  setInputDetailsError((prv: any) => {
                    return {
                      ...prv,
                      fromPincode: "",
                    };
                  });
                }}
              />
            </div>
          </div>
          <div className="col-md-6">
            <label>
              Remaining Distance <span className="color-red">*</span>
            </label>
            <div className="d-flex flex-row position-relative">
              <input
                type="number"
                onWheel={(event) => event.currentTarget.blur()}
                // className={`form-control`}
                className={`form-control ${
                  inputDetailsError?.remainingDistance ? "error-border" : ""
                }`}
                name="remaining_distance"
                // disabled
                value={
                  eWayBillExtend?.remaining_distance
                    ? eWayBillExtend?.remaining_distance
                    : ""
                }
                onChange={(e: any) => {
                  handleChange(e);
                  setInputDetailsError((prv: any) => {
                    return {
                      ...prv,
                      remainingDistance: "",
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-12">
            <label>
              Reason for Extension <span className="color-red">*</span>
            </label>
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Mode"}
              className={` ${
                inputDetailsError?.extendValidityReason
                  ? "error-border rounded"
                  : ""
              }`}
              // isLoading={userFetching}
              options={REASONS_FOR_EXTENSION}
              onChange={(e: any) => {
                setEWayBillExtend((prv: ExtendEWayBillPayloadType) => {
                  return {
                    ...prv,
                    extend_validity_reason: e?.value,
                  };
                });
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    extendValidityReason: "",
                  };
                });
              }}
              isSearchable={true}
              value={{
                value: eWayBillExtend?.extend_validity_reason
                  ? eWayBillExtend?.extend_validity_reason
                  : null,
                label: eWayBillExtend?.extend_validity_reason
                  ? eWayBillExtend?.extend_validity_reason
                  : "Select...",
              }}
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-12">
            <label>
              Extension Remark<span className="color-red">*</span>
            </label>
            <textarea
              className={`form-control ${
                inputDetailsError?.extendRemarks ? "error-border" : ""
              }`}
              name="extend_remarks"
              style={{ height: "64px", resize: "none" }}
              value={eWayBillExtend?.extend_remarks}
              onChange={(e: any) => {
                handleChange(e);
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    extendRemarks: "",
                  };
                });
              }}
              maxLength={50}
            />
          </div>
          <span className="input-length ml-3 mt-1">
            {returnInputFieldLength(eWayBillExtend?.extend_remarks?.length, 50)}
          </span>
        </div>

        <div className="row mt-2">
          <div className="col-md-6">
            <label>Consignment Status</label>
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Mode"}
              className={` ${
                inputDetailsError?.consignmentStatus
                  ? "error-border rounded"
                  : ""
              }`}
              onChange={(e: any) => {
                setEWayBillExtend((prv: ExtendEWayBillPayloadType) => {
                  return {
                    ...prv,
                    consignment_status: e?.value,
                  };
                });
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    consignmentStatus: "",
                    transitType: e?.value === "M" ? "" : prv.transitType,
                  };
                });
              }}
              isSearchable={true}
              options={CONSIGNMENT_STATUS}
              value={{
                value: eWayBillExtend?.consignment_status
                  ? eWayBillExtend?.consignment_status
                  : null,
                label:
                  eWayBillExtend?.consignment_status === "M"
                    ? "In Movement"
                    : eWayBillExtend?.consignment_status === "T"
                    ? "In Transit"
                    : "Select...",
              }}
            />
          </div>
          <div className="col-md-6">
            <label>
              Transit Type{" "}
              {/* {eWayBillExtend?.consignment_status !== "M" ? (
                <span className="color-red">*</span>
              ) : (
                ""
              )} */}
            </label>
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Mode"}
              className={` ${
                inputDetailsError?.transitType ? "error-border rounded" : ""
              }`}
              isDisabled={eWayBillExtend?.consignment_status === "M"}
              // isLoading={userFetching}
              onChange={(e: any) => {
                setEWayBillExtend((prv: ExtendEWayBillPayloadType) => {
                  return {
                    ...prv,
                    transit_type: e?.value,
                  };
                });
                setInputDetailsError((prv: any) => {
                  return {
                    ...prv,
                    transitType: "",
                  };
                });
              }}
              isSearchable={true}
              options={TRANSIT_TYPE}
              value={{
                value: eWayBillExtend?.transit_type
                  ? eWayBillExtend?.transit_type
                  : null,
                label: eWayBillExtend?.transit_type
                  ? eWayBillExtend?.transit_type
                  : "Select...",
              }}
            />
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-md-12">
            <label>Address Line 1</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control ${
                  inputDetailsError?.addressLine1 ? "error-border" : ""
                }`}
                disabled={eWayBillExtend?.consignment_status === "M"}
                name="address_line1"
                value={eWayBillExtend?.address_line1}
                onChange={(e: any) => {
                  handleChange(e);
                  setInputDetailsError((prv: any) => {
                    return {
                      ...prv,
                      addressLine1: "",
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-12">
            <label>Address Line 2</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control ${
                  inputDetailsError?.addressLine2 ? "error-border" : ""
                }`}
                disabled={eWayBillExtend?.consignment_status === "M"}
                name="address_line2"
                value={eWayBillExtend?.address_line2}
                onChange={(e: any) => {
                  handleChange(e);
                  setInputDetailsError((prv: any) => {
                    return {
                      ...prv,
                      addressLine2: "",
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-12">
            <label>Address Line 3</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control ${
                  inputDetailsError?.addressLine3 ? "error-border" : ""
                }`}
                name="address_line3"
                onChange={(e: any) => {
                  handleChange(e);
                  setInputDetailsError((prv: any) => {
                    return {
                      ...prv,
                      addressLine3: "",
                    };
                  });
                }}
                value={eWayBillExtend?.address_line3}
                disabled={eWayBillExtend?.consignment_status === "M"}
              />
            </div>
          </div>
        </div>

        <button className="btn btn-primary mt-5" onClick={handleSubmit}>
          Extend E-Way Bill
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  pinCodeDistanceCountData: state.invoiceGeneration.pinCodeDistanceCountData,
  pinCodeFetching: state.invoiceGeneration.pinCodeFetching,
  pinCodeError: state.invoiceGeneration.pinCodeError,
  stateList: state.masterData.stateList,
  cityList: state.masterData.cityList,
  countryFetching: state.masterData.countryFetching,
  stateFetching: state.masterData.stateFetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetGenerateEWayBillAction: (data: ExtendEWayBillPayloadType) =>
    dispatch(postExtendEWayBillAction(data)),
  dispatchResetEWayBillError: () => dispatch(resetEWayBillError()),
  dispatCheckDistanceCountAction: (data: DistanceCountPayloadType) =>
    dispatch(checkDistanceCountAction(data)),
  dispatchResetPinCodeError: () => dispatch(resetPinCodeError()),
  dispatchResetPinCodeDistanceCountData: () =>
    dispatch(resetPinCodeDistanceCountData()),
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) =>
    dispatch(getAllStateAction(data)),
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) =>
    dispatch(getAllCityAction(data)),
  dispatchResetStateList: () => dispatch(resetStateList()),
  dispatchResetCityList: () => dispatch(resetCityList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EWayBillExtend);
